// PageHint — a small one-liner shown under a page's H1 explaining where
// the page's content comes from and where it feeds. Deliberately not a
// prop of an H1 component; keeping this a standalone slot means we can
// drop it into any existing layout without refactoring headers.
//
// Usage:
//   <h1 className="font-serif text-3xl">Releases</h1>
//   <PageHint>From GitHub releases. Publishes to Timeline; rolls up into This week.</PageHint>
export function PageHint({ children }: { children: React.ReactNode }) {
  return (
    <p className="mt-1 max-w-[62ch] text-[13px] leading-snug text-text-tertiary">
      {children}
    </p>
  );
}
